import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "NexTech PLM Solutions";
const SITE_URL = "https://nextechplm.com";
const DEFAULT_DESCRIPTION =
  "NexTech PLM Solutions delivers Teamcenter implementation, PLM integrations, software engineering, and digital transformation services.";
const DEFAULT_IMAGE = `${SITE_URL}/favicon.ico`;

const normalizePath = (path = "/") => {
  if (!path || path === "/") {
    return "/";
  }

  return path.startsWith("/") ? path : `/${path}`;
};

const toAbsoluteUrl = (value, fallback = SITE_URL) => {
  if (!value) {
    return fallback;
  }

  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  return `${SITE_URL}${value.startsWith("/") ? value : `/${value}`}`;
};

const Seo = ({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  robots = "index, follow",
}) => {
  const canonicalUrl = toAbsoluteUrl(normalizePath(path));
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const imageUrl = image ? toAbsoluteUrl(image, DEFAULT_IMAGE) : null;

  return (
    <Helmet prioritizeSeoTags>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      {imageUrl ? <meta property="og:image" content={imageUrl} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      {imageUrl ? <meta name="twitter:image" content={imageUrl} /> : null}
    </Helmet>
  );
};

export default Seo;